import PropTypes from 'prop-types';

// @mui material components
import Card from "@mui/material/Card";

// Data
import { useMatch } from 'react-router-dom';


import { useQuery, useMutation } from '@tanstack/react-query';

import clearwaysAPI from 'modules/clearways/api';
import groupsAPI from 'services/api/groups';
import bksAPI from 'services/api/bks';

import EventForm from "modules/clearways/components/EventForm";


import { useAuth0 } from "@auth0/auth0-react";
import { Box } from "@mui/material";
import { disableMap } from "utils/map";
import { useSoftUIController } from "hooks/context";
import { wrapper, loadingScreen } from "utils/wrapper";
import { useEffect } from 'react';

function updateEvent(data) {
    // console.log(data);
    clearwaysAPI.saveClearwayEventWithID(data._id, data);
}

function ClearwaysEventEdit({ map, user }) {
    const [controller] = useSoftUIController();
    const { deviceLayout, selectedOrg } = controller;

    useEffect(() => {
        if (!map.current) return;
        disableMap(map, user, selectedOrg);
    }, [selectedOrg]);

    bksAPI.loadToken(useAuth0());
    groupsAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());

    const { event_id } = useMatch('clearways/events/:event_id/edit').params;

    const event = useQuery({
        queryKey: ['getClearwayEventWithID', event_id, selectedOrg],
        queryFn: async () => {
            return await clearwaysAPI.getClearwayEventWithID(event_id);
        }
    });

    const groups = useQuery({
        queryKey: ['getGroups', event_id, selectedOrg],
        queryFn: async () => {
            return await groupsAPI.getAllGroups();
        }
    });

    const devices = useQuery({
        queryKey: ['getAllDevices', selectedOrg],
        queryFn: async () => await bksAPI.getAllDevices(),
        refetchInterval: 300 * 1000,
        refetchIntervalInBackground: true,
    });

    const { mutate } = useMutation({
        mutationFn: (values) => updateEvent(values),
    })

    if (event.isLoading || groups.isLoading || devices.isLoading) {
        return loadingScreen(controller, true);
    }

    if (event.error || groups.error || devices.error) {
        return wrapper("Error!", controller);
    }

    if (!event.data || !groups.data || !devices.data) {
        return loadingScreen(controller, false);
    }

    return wrapper((
        <Box p={1}>
            <Card>
                <EventForm event={event.data} groups={groups} devices={devices.data} onSubmit={mutate} />
            </Card>
        </Box>
    ), controller, true
    );
}

ClearwaysEventEdit.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object
}

export default ClearwaysEventEdit;